import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { inventoryRuleSettingsLocationSchema } from "./inventory-rule-models";

const inventoryRuleWarehouseSchema = inventoryRuleSettingsLocationSchema.extend(
  {
    name: z.string(),
    /** False where the operator doesn't strictly scan the merchant's items, so the daily job skips scheduled steps. */
    strictScan: z.boolean(),
  },
);
export type InventoryRuleWarehouse = z.infer<
  typeof inventoryRuleWarehouseSchema
>;

/** The merchant's returns center warehouses, by name, with what their settings rows offer. */
export const listInventoryRuleWarehouses = unaryRpc({
  name: "listInventoryRuleWarehouses" as const,
  input: z.object({}),
  output: z.object({
    /** The merchant's offered grades, which the grade rows follow. */
    grades: z.array(z.string()),
    warehouses: z.array(inventoryRuleWarehouseSchema),
  }),
});
